import { UserRole } from '@lmc/ts-common'
import { Button, Chevron } from '@lmc/ui-kit'
import { Dropdown } from 'antd'
import { useRoleAccess } from 'components/AccessControl'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'

type ReviewLogDropdownButtonProps = {
  onCloseIncidentClick: () => void
  onCreateCaseClick: () => void
}

const ReviewLogDropdownButton = ({
  onCloseIncidentClick,
  onCreateCaseClick,
}: ReviewLogDropdownButtonProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const hasRolePermission = useRoleAccess(
    [UserRole.careHomeAdmin, UserRole.seniorCarer],
    [
      {
        i: 'create',
        this: 'Incident',
      },
    ],
  )

  const hasRolePermissionToClose = useRoleAccess(
    [UserRole.careHomeAdmin],
    [
      {
        i: 'update',
        this: 'Incident',
      },
    ],
  )

  return (
    <Dropdown
      menu={{
        items: [
          ...(hasRolePermissionToClose
            ? [
                {
                  label: t(incidentReportsConstants.CLOSE_INCIDENT),
                  key: '1',
                  onClick: onCloseIncidentClick,
                },
              ]
            : []),

          ...(hasRolePermission
            ? [
                {
                  label: t(incidentReportsConstants.CREATE_CASE),
                  key: '2',
                  onClick: onCreateCaseClick,
                },
              ]
            : []),
        ],
      }}
      trigger={['click']}
    >
      <Button variant="primary">
        Review
        <Chevron direction="down" />
      </Button>
    </Dropdown>
  )
}

export default ReviewLogDropdownButton
